import React from 'react'
import PropTypes from 'prop-types'

import Component from '../common/Component'
import withRouter from '../../lib/withRouter'
import IndexComponent from '../common/IndexComponent'
import actions from '../../actions/Platforms'
import connectIndex from '../../lib/connectIndex'
import { DocumentIndex } from '../Documents/DocumentIndex'

export class PlatformIndex extends Component {
  static propTypes = {
    location: PropTypes.object,
    index: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    records: PropTypes.array,
    pagination: PropTypes.object,
    flashMessages: PropTypes.array.isRequired,
    filterActions: PropTypes.object,
    filters: PropTypes.object,
    searchColumns: PropTypes.array,
    history: PropTypes.func.isRequired
  }

  static searchColumns = ['name']

  static defaultProps = {
    searchColumns: this.searchColumns
  }

  static columns = [
    {
      key: 'id',
      label: 'ID',
      filterable: false,
      sortable: true
    },
    {
      key: 'name',
      label: 'Platform Name',
      filterable: false,
      sortable: true
    },
    {
      key: 'created_at',
      label: 'Upload Date',
      display: DocumentIndex.dateDisplay,
      filterable: false,
      sortable: true
    }
  ]

  render() {
    return (
      <div className="content">
        <IndexComponent
          fetchRecords={this.props.index}
          resetRecords={this.props.reset}
          location={this.props.location}
          path="/platforms"
          name="Platform"
          pagination={this.props.pagination}
          columns={PlatformIndex.columns}
          flashMessages={this.props.flashMessages}
          records={this.props.records}
          filterValues={this.props.filters}
          filterActions={this.props.filterActions}
          searchPlaceholder="Search by Platform Name"
          searchColumns={this.props.searchColumns}
          actions={[]}
          history={this.props.history}
          filterable
        />
      </div>
    )
  }
}

export default connectIndex(withRouter(PlatformIndex), 'platforms', actions)
